import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})

export class CallCheckListService {


//   getBuildingData1() {

//     return [

//      'Building 1',

//   'Building 2' ,

//      'Building 3',

//    'Building 4' 

//     ];

//   }

//   getLeakedData1() {

//     return [

//      'Leaked 1 ' ,

//     'Leaked 2' ,

//      'Leaked 3' ,

//       'Leaked 4' ,

//     ];

//   }

//   //Adviseries
//   getAdvisoriesData() {
//     return [
//         {
//             id: 1,
//             title: 'In order to ensure your safety, our technician will need to access the meter and /or building.',
//             checked: false,
//         },
//         {
//             id: 2,
//             title: 'If an adult 18 or older is not available to provide access, the technician may request a locksmith and police escort or the gas may be turned off until an investigation can be completed',
//             checked: false,
//         },
//         {
//             id: 3,
//             title: 'How can the technician gain access to the meter or building?',
//             checked: false,
//         },
//         {
//             id: 4,
//             title: 'For your safety, we advise that you wait somewhere safe away from the emergency situation but where you can meet the technician. Where will you be waiting for the technician?',
//             checked: false,
//         },
//         {
//             id: 5,
//             title: 'Thank you for the information given, now I would like to give you a few advisories for your safety.',
//             checked: false,
//         },
//         {
//             id: 6,
//             title: 'Please call 911 from a safe location away from the emergency.',
//             checked: false,
//         },
//         {
//             id: 7,
//             title: 'We advise that you put out any open flames such as candles; do not light any matches, lighters, or anything that may have a flame.',
//             checked: false,
//         },
//         {
//             id: 8,
//             title: 'To avoid any possible sparks do not turn on/off any switches, electrical devices or lights. This includes garage door openers and outside lights.',
//             checked: false,
//         },
//         {
//             id: 9,
//             title: 'Our technician will arrive as soon as possible.',
//             checked: false,
//         },
//         {
//             id: 10,
//             title: 'Reminder: Recap address, city, state, and safe phone number',
//             checked: false,
//         },
//         {
//             id: 11,
//             title: 'Disclosure-I certify that I have given all advisories to the caller as presented.',
//             checked: false,
//         },
  
//     ];
//   }
  
//   getOtherData1() {
//     return [
//         {
//             id: 1,
//             title: 'Our technician will arrive as soon as possible.',
//             checked: false,
//         },
//         {
//             id: 2,
//             title: 'Reminder: Recap address, city, state, and safe phone number',
//             checked: false,
//         },
//         {
//             id: 3,
//             title: 'Disclosure-I certify that I have given all advisories to the caller as presented.',
//             checked: false,
//         },
//     ];
//   }

//   getOtherData() {
//     return [
//         {
          
//             title: 'Our technician will arrive as soon as possible.',
//             checked: false,
//         },
//         {
         
//             title: 'Reminder: Recap address, city, state, and safe phone number',
//             checked: false,
//         },
//         {
          
//             title: 'Disclosure-I certify that I have given all advisories to the caller as presented.',
//             checked: false,
//         },
//     ];
//   }
  
//   getPassedByData() {
//     return [
//         {
//             id: 1,
//             title: 'For your safety, we advise that you stay out of the area.',
//             checked: false,
//         },
//         {
//             id: 2,
//             title: 'Our technician will arrive as soon as possible.',
//             checked: false,
//         },
//         {
//             id: 3,
//             title: 'Reminder: Recap address, city, state, and safe phone number',
//             checked: false,
//         },
//         {
//             id: 4,
//             title: 'Disclosure-I certify that I have given all advisories to the caller as presented.',
//             checked: false,
//         }
//     ];
//   }
}